import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_CORGI_FILTER_TRANSLATIONS = createFcmConfig('corgi_filter_translations', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
